import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ComponentRendering, Field } from '@sitecore-jss/sitecore-jss/layout';
import { combineLatest, Subscription } from 'rxjs';
import { IProduct } from '../../dashboard/services/account-overview.service';
import {
  DefaultPortfolioResponse,
  DefaultPortfolioService
} from '../../shared/services/default-portfolio.service';
import {
  IPortfolio,
  PortfolioService
} from '../../shared/services/portfolio.service';
import {
  DialogState,
  DialogStateService
} from './../../dialogs/services/dialog-state.service';

import { FullPortfolioViewService } from '../../shared/services/full-portfolio-view.service';

@Component({
  selector: 'ab-portfolio-setting',
  templateUrl: './portfolio-setting.component.html',
  styleUrls: ['./portfolio-setting.component.scss']
})
export class PortfolioSettingComponent implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering;

  public portfolios: Array<IPortfolio>;
  private subscription: Subscription;
  private subscriptions: Subscription[] = [];
  private dialogStateSubscription: Subscription;
  private fullPortfolioViewSubscription: Subscription;
  public tooltipInfo: Field;
  public accounts: IProduct[] = [];
  public accountDetails: { [key: string]: IProduct } = {};
  public isLoading: boolean = true;
  public popupIsOpen: boolean;
  public defaultPortfolio: DefaultPortfolioResponse;
  constructor(
    private portfolioService: PortfolioService,
    private dialogStateService: DialogStateService,
    private defaultPortfolioService: DefaultPortfolioService,
    private fullPortfolioViewService: FullPortfolioViewService
  ) {}

  ngOnInit() {
    this.isLoading = true;
    this.subscriptions.push(
      this.fullPortfolioViewService
        .getFullPortfolioView()
        .subscribe(accounts => {
          this.subscription = combineLatest(
            this.portfolioService.getPortfolios(),
            this.defaultPortfolioService.getPortfolio()
          ).subscribe(([portfolios, defaultPortfolio]) => {
            this.isLoading = false;
            this.portfolios = portfolios.portfolios;
            this.accountDetails = accounts.bankAccounts;
            this.defaultPortfolio = defaultPortfolio;
            this.setAccountOptions();
            this.setDefaultPortfolio();

            this.dialogStateService.updateDialogState(
              'DefaultPortfolioSelector',
              {
                selectedPortfolio: this.defaultPortfolio,
                portfolios: this.portfolios,
                accounts: this.accounts,
                isLoading: false
              },
              this.popupIsOpen === true ? DialogState.Open : DialogState.Close
            );
          });
        })
    );

    this.tooltipInfo = this.rendering.fields.tooltip as Field;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.dialogStateSubscription) {
      this.dialogStateSubscription.unsubscribe();
    }
    if (this.fullPortfolioViewSubscription) {
      this.fullPortfolioViewSubscription.unsubscribe();
    }
  }

  setDefaultPortfolio() {
    this.portfolios.forEach(portfolio => {
      portfolio.isDefault =
        portfolio.id === this.defaultPortfolio.portfolioNumber;
    });
  }

  setAccountOptions(accountsDetails?: { [key: string]: IProduct }) {
    this.accounts = Object.values(
      this.accountDetails || accountsDetails
    ).filter(accounts => accounts?.status === 'open');
  }

  openDialog() {
    if (this.defaultPortfolio && this.defaultPortfolio.portfolioNumber) {
      this.setDefaultPortfolio();
    }

    this.setAccountOptions();
    this.popupIsOpen = true;
    this.dialogStateService
      .openDialog('DefaultPortfolioSelector', {
        portfolios: this.portfolios,
        accounts: this.accounts,
        isLoading: this.isLoading
      })
      .subscribe(result => {
        if (result) {
          this.popupIsOpen = false;
          this.defaultPortfolioService
            .getPortfolio()
            .subscribe(
              defaultPortfolio => (this.defaultPortfolio = defaultPortfolio)
            );
          this.fullPortfolioViewService.clearBankAccounts();
          this.fullPortfolioViewSubscription = this.fullPortfolioViewService
            .getFullPortfolioView()
            .subscribe(accountsDetails => {
              this.accountDetails = accountsDetails.bankAccounts;
            });
        }
      });

    this.dialogStateSubscription = this.dialogStateService
      .getDialogState()
      .subscribe(state => {
        if (state.dialogState)
          this.popupIsOpen =
            state.dialogState === DialogState.Open ? true : false;
      });
  }
}
